import { styled } from '@mui/material';

import { useNavigate, useParams } from 'react-router';

import { Typography, Box, Button } from '@app-velocity/ui';

import { useI18n } from '@app-velocity/i18n';
import { AddPeopleIcon, ShareIcon } from '@app-velocity/icons';
import { ScenarioRoutePaths } from '@app-velocity/modules/scenarios';

const StyledBox = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  whiteSpace: 'pre-wrap',
  flex: 1,
  gap: theme.spacing(4),
  padding: theme.spacing(8),
  border: '1px solid var(--stroke-stroke-primary-color)',
  borderRadius: theme.spacing(2),
}));

const StyledHeader = styled('header')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  fontSize: 16,
  fontWeight: 700,
  svg: {
    fill: 'var(--info-info-icon-primary-color)',
  },
}));

const StyledText = styled(Typography)({
  fontSize: 13,
  fontWeight: 300,
});

export const SetUp = () => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { teamId, workspaceId, scenarioId } = useParams<{
    teamId: string;
    workspaceId: string;
    scenarioId: string;
  }>();

  const goToHumanTestingConfig = () => {
    if (!workspaceId || !teamId || !scenarioId) return;
    navigate(
      ScenarioRoutePaths.setUpHumanTesting(teamId, workspaceId, scenarioId)
    );
  };

  return (
    <StyledBox>
      <StyledHeader>
        <AddPeopleIcon />
        <span>{t('prototypes:human_testing')}</span>
      </StyledHeader>
      <StyledText>{t('prototypes:human_testing_text')}</StyledText>
      <Button
        onClick={goToHumanTestingConfig}
        variant="contained"
        color="secondary"
      >
        {t('prototypes:set_up_human_testing')}
        <ShareIcon />
      </Button>
    </StyledBox>
  );
};
